import { useEffect, useRef } from "react";
const emptyObject = {};
function useFormFieldMutations(formApi, _updateMode, _name, _fields, config = emptyObject, verbose) {
  const { fieldMutations } = config;
  const prevSource = useRef({ config, verbose });
  useEffect(() => {
    const verbose2 = prevSource.current.verbose;
    const prevFieldMutations = prevSource.current.config.fieldMutations;
    if (prevFieldMutations) {
      for (const mutation of prevFieldMutations) {
        formApi.removeFieldMutation(mutation.field);
        if (verbose2) console.log(`[useCreateForm] -- remove Field Mutation: ${String(mutation.field)}`);
      }
    }
    if (fieldMutations) {
      for (const mutation of fieldMutations) {
        formApi.addFieldMutation(mutation.field, mutation.mutation);
        if (verbose2) console.log(`[useCreateForm] -- add Field Mutation: ${String(mutation.field)}`);
      }
    }
  }, [formApi, fieldMutations]);
  useEffect(() => void (prevSource.current = { config, verbose }), [config, verbose]);
}
export {
  useFormFieldMutations
};
//# sourceMappingURL=useFormFieldMutations.js.map
